// extracted by mini-css-extract-plugin
export default {"container":"Container_container__OXBTj","fluid":"Container_fluid__6DEPO"};